/* ***** ----------------------------------------------- ***** **
** ***** Global Scripts JS
** ***** ----------------------------------------------- ***** */

/* global jQuery, Main, Modernizr, TweenMax, Power1, autosize */
(function($){
	'use strict';

	Main.modules.globalScripts = function() {

		var $body = $('body'),
			$html = $('html'),
			$inputFieldShowLabel = $('.js-input_field_show_label'),
			$inputFieldTextarea = $('.o-input_field-input--textarea'),
			$modalContainerOverlay = $('.c-modal_container-overlay'),
			$modalToggle = $('.js-subscribe_modal_toggle, .js-contact_modal_toggle, .js-modal_toggle'),
			$searchForm = $('.o-search_form'),
			$searchFormButtonClose = $('.o-search_form-button--close'),
			$searchFormSlideout = $('.o-search_form-slideout'),
			$searchToggle = $('.js-search_toggle'),
			$siteContainerOverlay = $('.l-site_container_overlay'),
			$textareaAutoSize = $('.js-textarea_autosize'),
			$modal,
			$modalFadeIn,
			searchActionURL = $('.o-search_form').attr('action'),
			staggerDuration = 0.05,
			transitionDurationModal = 0.3,
			transitionDurationSearch = 0.25,
			upgradeMessage = '<div class="c-upgrade_browser_message"><a href="http://outdatedbrowser.com/" class="c-upgrade_browser_message-link" target="_blank">For a better experience, please upgrade your browser to the latest version. Click here upgrade.</a></div>',
			searchURL,

			modernizrCheck = function() {

				// Display message for user to upgrade if browser does not support flexbox
				if (Modernizr['flexbox'] == false) {
					$body.append(upgradeMessage);
				}

			},

			searchToggle = function() {

				$searchToggle.on('click', function(e) {

					var $this = $(this),
						$searchFormInput = $('.o-search_form-input', '.o-search_form--header');

					// If input field is empty and the submit button is pressed, do nothing
					if ($searchFormInput.val() == '' &&
						$this.hasClass('o-search_form-button--submit')) {
						e.preventDefault();
					} 
					
					// If search form is closed, expand
					if (!$searchFormSlideout.hasClass('o-search_form-slideout--is_active')) {

						// Expand and animate
						$searchFormSlideout.addClass('o-search_form-slideout--is_active');

						TweenMax.to($searchFormSlideout, transitionDurationSearch, {
							opacity: 1,
							ease: Power1.easeInOut
						});

						TweenMax.to($searchFormInput, transitionDurationSearch, {
							width: '20rem',
							ease: Power1.easeInOut
						});

						// Focus the text cursor in the input field
						$searchFormInput.focus();

					} else {

						// If input field is empty, collapse and hide
						if ($searchFormInput.val() == ''
							|| $this.hasClass('o-search_form-button--close')) {

							TweenMax.to($searchFormSlideout, transitionDurationSearch, {
								opacity: 0,
								ease: Power1.easeInOut
							});

							TweenMax.to($searchFormInput, transitionDurationSearch, {
								width: '0',
								ease: Power1.easeInOut
							});

							setTimeout(function(){
								$searchFormSlideout.removeClass('o-search_form-slideout--is_active');
							}, 250);

							// Clear input field
							$searchFormInput.val('');
						}

					}
					
				});

			},

			searchSubmit = function() {

				$searchForm.on('submit', function(e) {
					e.preventDefault();

					var $this = $(this),
						searchInputValue = $this.find('.o-search_form-input').val();

					// If search input contains text, run search and push URL to history
					if (searchInputValue != '') {
						searchURL = searchActionURL + '?' + $this.serialize();
						History.pushState({randomData: Math.random()}, '', searchURL);

						// If the slideout menu search form is used, close slideout menu upon submission
						// Otherwise (header search form is used), collapse input field
						if($this.hasClass('o-search_form--slideout_menu')) {
							$siteContainerOverlay.click();
						} else {
							$searchFormButtonClose.click();
						}
					}

				})

			},

			inputFieldShowLabel = function() {

				$inputFieldShowLabel.on('input', function() {

					var $this = $(this),
						$thisLabel = $this.parent().prev();

					// When the user starts typing, move label above input field
					if ($this.val() != '') {
						if(!$thisLabel.hasClass('o-input_field-input_label--is_active')){
							$thisLabel.addClass('o-input_field-input_label--is_active');
						}
					} else {
						$thisLabel.removeClass('o-input_field-input_label--is_active');
					}
					
				});

			},

			textareaUpdate = function() {
				// Overwrite the contact form 7 default value and set the number of rows to 1
				$inputFieldTextarea.attr('rows', '1');

				// Expand text area as user types in it
				autosize($textareaAutoSize);
			},

			modalToggle = function() {

				$modalToggle.on('click', function() {

					var $this = $(this);

					// Set selector based on button action
					if ($this.hasClass('js-subscribe_modal_toggle')) {
						$modal = $('.c-modal--subscribe');
					} else if ($this.hasClass('js-contact_modal_toggle')) {
						$modal = $('.c-modal--contact'); 
					} else {
						$modal = $('.c-modal'); 
					}

					$modalFadeIn = $('.c-modal-fade_in', $modal);

					if (!$html.hasClass('l-modal--is_active')) {

						$html.addClass('l-modal--is_active');
						$modal.css('display', 'block');

						TweenMax.to($modalContainerOverlay, transitionDurationModal, {
							opacity: '1',
							ease: Power1.easeInOut
						});

						TweenMax.to($modal, transitionDurationModal, {
							opacity: '1',
							y: '-10',
							scale: 1,
							ease: Power1.easeInOut
						});

						// Stagger fade in content
						TweenMax.staggerFrom($modalFadeIn, transitionDurationModal, {
							opacity: 0,
							y: 10,
							ease: Power1.easeInOut,
							delay: 0.15
						}, staggerDuration);

					} else {

						TweenMax.to($modalContainerOverlay, transitionDurationModal, {
							opacity: '0',
							ease: Power1.easeInOut
						});

						TweenMax.to($modal, transitionDurationModal, {
							opacity: '0',
							y: '0',
							scale: 0.98,
							ease: Power1.easeInOut
						});

						setTimeout(function() {
							$html.removeClass('l-modal--is_active');
							$modal.css('display', 'none');
						}, 400);

					}

				});

			};

		return {
			init: function() {
				modernizrCheck();
				searchToggle();
				searchSubmit();
				inputFieldShowLabel();
				modalToggle();
				textareaUpdate();
			}
		}
		
	};

})(jQuery);